export const SET_USER_LOCATIONS = "SET_USER_LOCATIONS";
export const SET_STATUSES_LIST = "SET_STATUSES_LIST";
export const SET_LOCATION_DETAIL = "SET_LOCATION_DETAIL";
export const SET_VAR_DETAIL_LOCATION_LIST = "SET_VAR_DETAIL_LOCATION_LIST";
export const DELETE_USER_LOCATION = "DELETE_USER_LOCATION";
export const SET_THIRD_PARTY_LOCATIONS = "SET_THIRD_PARTY_LOCATIONS";
